import { connect } from "react-redux";

import { getOrganizationNameByInnAction } from "../../../Engine/ActionCreators/PicklistActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { INN } from "./INN";

interface INNContainerProps {
    bindingPath: AbsoluteModelPath;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: INNContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;

    return {
        value: viewModelSelect.controlModel(state, bindingPath).value ?? "",
        isHideOrgName: state.formVisualState.isHideOrgName,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onGetOrganizationNameByInn: (inn: string) => dispatch(getOrganizationNameByInnAction(inn)),
});

export const INNContainer = withResolvePaths(
    withViewModelSelect(connect(mapStateToProps, mapDispatchToProps)(withControlDebugInfo(INN)))
);
